import cloneDeep from 'clone-deep'
import { LayoutLoading } from 'components/LayoutLoading'
import { accountTypeWithBorrower } from 'config'
import { useEffect, useState } from 'react'
import { getAdminConfig, setAdminConfig } from 'services'
import { ButtonGroup } from 'stories/components'
import { RenderInput } from 'utils/RenderInput'

export const EmailPartiesConfig = () => {
  const [isLoading, setLoading] = useState(false)
  const [data, setData] = useState<Record<string, any>>({})
  const [account, setAccount] = useState('borrower')

  useEffect(() => {
    setLoading(true)
    getAdminConfig('emailParties').then((res) => {
      setData(res)
      setLoading(false)
    })
  }, [])

  const onChange = async (key: string, value: any) => {
    const temp = cloneDeep(data)
    temp[key][account] = value
    setData(temp)
    setLoading(true)
    await setAdminConfig('emailParties', temp)
    setLoading(false)
  }

  return (
    <div>
      <LayoutLoading show={isLoading} />
      {false && <ButtonGroup title={accountTypeWithBorrower()} value={account} onChange={setAccount} sort />}
      <RenderInput
        input={{
          inputType: 'togglebutton',
          title: 'Enable / Disable Email',
          value: data.emailEnabled?.[account],
        }}
        Key="emailEnabled"
        onChange={onChange}
      />
    </div>
  )
}
